exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only print{.app-main,.content-wrapper,.main-content-wrapper,body.advanced-planning-portal main{overflow:unset!important}}", ""]);

// exports
